import { httpCreate } from './http';

const http = httpCreate('/srv/material-personal');

export const materialPersonal = {
	getList(params) {
		return http.get('/list', { params });
	},
	use(id, params = {}, body = {}) {
		return http.post(`/use/${id}?photoLive=0`, body, { params });
	},
	// 获取上传token
	uploadToken(params) {
		return http.get('/uploadToken', {
			params,
		});
	},
};
